/* 
 * Main javascript
 */
 
jQuery(function($) {
	var selectCount = 600;

	function Select(el){
		var viewVal = $(el).find(".view-val");
		var arrow   = $(el).find(".arrow");
		var ul      = $(el).find(".wrap-ul");
		var hideVal = $(el).find(".hide-val");
		var selected = $(ul).find("li.selected");
		$(this).hover(function() {
			$(ul).css({
				"z-index" : 700
			});
		}, function() {
			$(ul).css({
				"z-index" : 600
			});
		});
		$(viewVal).html( $(selected).html() );
		$(hideVal).val( $(selected).data("value") );
		$( viewVal ).click(function(event) {
			$(ul).slideToggle();
		});
		$( arrow ).click(function(event) {
			$(ul).slideToggle();
		});
		$(ul).find("li").click(function(event) {
			var value = $(this).data("value");
			var text  = $(this).html();
			var siblings = $(this).siblings('li');
			$(siblings).removeClass('selected');
			$(this).addClass('selected');
			$(viewVal).html( text );
			$(hideVal).val( value );
			$(ul).slideToggle();
			$(hideVal).trigger('change');
		});
	}

	function AjaxFunction(form){
		var _parent = $(form);

		$(_parent).find(".add-to-cart-variation").click(function(event) {
			var _this = $(this);

			var variation_id = $(_parent).find("input[name=variation_id]").val(),
			product_id = $(_parent).find("input[name=product_id]").val(), attributes = {};

			$(_parent).find("input[name^=attribute]").not("input[type=submit]").each(function(index, el) {
				var name = $(el).attr("name");
				attributes[name] = $(el).val();
			});

			$(this).removeClass('added error').addClass('loading');
			$.ajax({
				url: jsData.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: { 
					action: 'add_to_cart_variation_subscription',
					product_id : product_id,
					variation_id : variation_id,
					attributes : attributes,
					nonce : jsData.ajax_nonce
				},
				success : function( data ){
					if( typeof data.fragments != "undefined" ){
						var mod = $( data.fragments["div.mod-cart"] ).html(),
						pc = $( data.fragments["ul.cart-click"] ).html();
						detail = $( data.fragments["div.widget_shopping_cart_content"] ).html();
						
						$("div.mob-cart").html( mod );
						$("ul.cart-click").html( pc );
						$("#footer .cart ul").html( pc );
						$("div.widget_shopping_cart_content").html( detail );
						$(_this).removeClass('loading').addClass('added');

						//redirect to checkout page after add success
						window.location.href = jsData.checkout_url;

					}else if( typeof data == "number" && data <= 0 ){
						$(_this).removeClass('loading').addClass('error');
					}
					
					
				},
				complete : function( data ){

				}
			});
			
			return false;
		});
	}

	$(".custom-select").each(function(index, el) {
		Select(el);
	});
	$(".custom-qty").each(function( index, el ){
		var input = $(this).find(".qty"),
		plus = $(this).find(".plus"),
		minus = $(this).find(".minus");
		$(input).change(function(event) {
			if( isNaN( $(input).val() ) || parseInt( $(this).val() ) < 1 ){
				$(input).val( 1 );
			}
		});
		$(plus).click(function(event) {
			var qty =  parseInt( $(input).val() );
			if( isNaN( $(input).val() )  ){
				$(input).val( 1 );
			}else{
				$(input).val( qty + 1 );
			}
			$(input).trigger('change');
		});
		$(minus).click(function(event) {
			var qty =  parseInt( $(input).val() );
			if( isNaN( $(input).val() ) ){
				$(input).val( 1 );
			}else if( qty > 1 ){
				$(input).val( qty - 1 );
			}
			$(input).trigger('change');
		});
	});
	$(document).on( "change", ".custom-variations .custom-select .hide-val", function(){
		var form = $(this).parents(".custom-variations");
		var data = $(form).data("product-variations");
		var attr_name = $(this).parents(".custom-select").data("attribute-name");

		var attribute = {};
		// build attribute 
		$(form).find('.custom-select').each(function(index, el) {
			var attr_name = $(this).data("attribute-name");
			attribute[attr_name] = $(this).find(".hide-val").val();
		});
		
		$.each( data, function(index, el) {
			var match = true;
			for(var key in el.attributes){
			    if(el.attributes.hasOwnProperty(key) && el.attributes[key] != attribute[key] ) {
			       match = false;
			       break;
			    }
			}
			if(match){
				if(el.variation_is_active && el.variation_is_visible 
					&& el.is_purchasable && el.is_in_stock){
					$(form).find(".price").html(el['price_html_2']);
					$(form).find("button").prop("disabled", false);
				}else {
					$(form).find(".price").html($(el.availability_html));
					$(form).find("button").prop("disabled", true);
				}
				
				$(form).find("input[name=variation_id]").val(el.variation_id);
			}
		});
	});
	
	$(".custom-variations").each(function(index, el) {
		AjaxFunction(el)
	});
	// check version ie
	function isIE() {
	  var myNav = navigator.userAgent.toLowerCase();
	  return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
	}
	/*
		Menu Sticky
	*/
	$(window).scroll(function(event) {
		var header = $("#wrapper-header"), offsetTop = $(window).scrollTop();
		var headerH = $(header).outerHeight();
		var v = viewport();
		var w = v['width'];
		if( w > 991 ){
			if( offsetTop > 100 && !$(header).hasClass('fixed') ){
				$(header).hide().addClass('fixed').css({
					top : -5000 + "px"
				});
				$(header).show().animate({
					top : 0 + "px"
				}, 500 );
			}else if( offsetTop < 100 && $(header).hasClass('fixed') ){
				$(header).removeClass('fixed').removeAttr('style');
			}
		}else{
			$(header).removeClass('fixed').removeAttr('style');
		}
		
	});
	/*
		Add background image for div element
	*/
	// $("img.lazy-img-loading").unveil();
	// $("img.lazy-img-loading").unveil(200, function() {
	// 	$(this).load(function() {
	//     	var parent = $(this).parents(".lazy-loading"), _this = $(this);
	//     	if( parent.is(".lazy-loading") ){
	//     		$(parent).css({
	//     			"background-image" : "url(" + $(_this).attr("src") + ")"
	//     		});
	//     		$(parent).removeClass('lazy-loading');
	//     		if( $(_this).hasClass('lazy-img-loading-hide') ){
	//     			$(_this).addClass('hidden');
	//     			$(_this).removeClass('lazy-img-loading');
	//     			$(_this).removeClass('lazy-img-loading-hide');
	//     		}else{
	//     			$(_this).removeClass('lazy-img-loading');
	//     		}
	//     	}else{
	//     		$(_this).removeAttr('style');
	//     		$(_this).removeClass('lazy-img-loading');
	//     		// handle for gray sale
	//     		var prev = $(_this).prev(".BWFilter");
	//     		if( $(prev).is(".BWFilter") ){
	//     			$(prev).attr("src", $(_this).attr("src") );
	//     		}
	//     	}
	//   	});
	// 	if( isIE() && isIE() < 20 ){
	// 		$(this).trigger('load');
	// 	}
	// });
	/*
		Scroll To
	*/
	function ScrollTo( url ){
		var hash = url.split("#");
		if( hash.length > 1 ){
			var id = "#" + hash[1];
			if( $("body").find( id ).length > 0 ){
				var offset = $(id).offset();
				var top = offset.top;
				//handle for product
				if( $(id).hasClass('block-product') ){

					var button  = $(id).find(".button"),
						box_el  = $(id).find(".box"),
						heading = $(id).find(".heading"),
						windowH = $(window).outerHeight();
					
					var h_1 = $(id).outerHeight(),
						h_2 = $(box_el).outerHeight();
					var delta = ( h_1 - h_2 )/2;
					
					//top = Math.abs( $(box_el).offset().top - delta - ( $("#wrapper-header").outerHeight() - delta ) );
					top = $(heading).offset().top - $("#wrapper-header").outerHeight();
				}
				$("html,body").animate({
					scrollTop: top
					},
					1000, function() {
				});
			}else{
				window.location.href = url;
			}

		}
	}
	function viewport() {
	    var e = window, a = 'inner';
	    if (!('innerWidth' in window )) {
	        a = 'client';
	        e = document.documentElement || document.body;
	    }
	    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	}
	/*
		
	*/
	$(".menu-item-shop a").click(function(event) {
		var href = $(this).attr("href");
		ScrollTo( href );
		return false;
	});
	$("li.scroll-to").click(function(event) {
		var href = $(this).find(">a").attr("href");
		ScrollTo( href );
		return false;
	});
	$("a.scroll-to").click(function(event) {
		var href = $(this).attr("href");
		ScrollTo( href );
		return false;
	});
	/*
		Responsive menu remove style when screen size > 991
	*/
	function MenuResponsive(){
		var v = viewport();
		var w = v['width'];
		if( w > 991 ){
			$("#nav-main .menu-item-has-children").find("ul").removeAttr('style');
		}
	}
	/*
		Add to cart variation - just for homepage
	*/
	if ( $("body").hasClass("page-template-page-home-php") ) {

		$(".block-add-to-cart").each(function(index, el) {
			
			var _parent = $(this);
			var addToCart = $(_parent).find(".add-to-cart-variation"),
			qtyEl = $(_parent).find( "input[name=qty]" ),
			variationIdEl = $(_parent).find("input[name=variation_id]"),
			salePriceEl = $(_parent).find(".sale-price"),
			regularPriceEl = $(_parent).find(".regular-price"),
			priceFormat = jsData.price_format,
			currency_symbol = jsData.currency_symbol;


			$(variationIdEl).add(qtyEl).change(function(event) {
				var selected = $(_parent).find( ".product-select-item li.selected" );
				var qty = $(qtyEl).val(),
				salePrice = $(selected).data("sale-price"),
				regularPrice = $(selected).data("regular-price");

				nsp = $.number( qty * salePrice, jsData.num_decimals, jsData.decimal_sep, jsData.thousand_sep );
				nrp = $.number( qty * regularPrice, jsData.num_decimals, jsData.decimal_sep, jsData.thousand_sep );

				nspFormated = priceFormat.replace( "%1$s", currency_symbol ).replace( "%2$s", nsp );
				nrpFormated = priceFormat.replace( "%1$s", currency_symbol ).replace( "%2$s", nrp );

				$(salePriceEl).html( nspFormated );
				$(regularPriceEl).html( nrpFormated );
			});
			$(addToCart).click(function(event) {
				var variation_id = $(variationIdEl).val(), 
				qty = $(qtyEl).val(), product_id = $(this).data("product-id"), _this = $(this);
				$(_this).removeClass('added').addClass('loading');
				$.ajax({
					url: jsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: { 
						action: 'add_to_cart_variation',
						product_id : product_id,
						variation_id : variation_id,
						qty : qty,
						nonce : jsData.ajax_nonce
					},
					success : function( data ){
						if( typeof data.fragments != "undefined" ){
							var mod = $( data.fragments["div.mod-cart"] ).html(),
							pc = $( data.fragments["ul.cart-click"] ).html();
							detail = $( data.fragments["div.widget_shopping_cart_content"] ).html();
							
							$("div.mob-cart").html( mod );
							$("ul.cart-click").html( pc );
							$("#footer .cart ul").html( pc );
							$("div.widget_shopping_cart_content").html( detail );
						}
						$(_this).removeClass('loading').addClass('added');
					},
					complete : function( data ){

					}
				});
				
				return false;
			});

		});
	}
	/*
		Tab - Accordion
	*/
	if( $("body").find(".block-tab").is(".block-tab") ){
	    $('.block-tab.tab').responsiveTabs({
	        activate: function( event, tab ){
	    	}
		});
		$('.block-tab.accordion').responsiveTabs({
	    	animation: 'slide',
	        activate: function( event, tab ){
	    	},
	    	load: function(event, firstTab){
	    		//$(firstTab.accordionAnchor[0]).trigger('click');
	    	}
		}).responsiveTabs('deactivate', 0);
	}

	if( $("body").find(".block-tab-subscription").is(".block-tab-subscription") ){
		$('.block-tab-subscription.accordion').responsiveTabs({
	    	animation: 'slide',
	        activate: function( event, tab ){}
		});
		$('.block-tab-subscription.accordion').responsiveTabs('deactivate', 0);
	}

	/*
		Show mini cart
	*/
	$(document).on( "click", ".cart-click", function(){
		var next = $(this).next(".cart-detail");
		var _this = $(this);
		if( $(next).is(":hidden") ){
			$(next).slideDown("fast",function(){
				$(_this).addClass('active');
			});
			
		}else{
			$(next).slideUp("fast",function(){
				$(_this).removeClass('active');
			});
		}
	} );
	/*
		Handle click show sub menu
	*/
	$("#nav-main .menu-item-has-children").each(function(){
		var span = $('<span class="arrow"></span>');
		$(this).find(">a").append(span);
	});
	$("#nav-main li.menu-item-has-children > a").click(function(event) {
		var next = $(this).next("ul");
		if( $(event.target).hasClass('arrow') ){
			if( $(next).is(":hidden") ){
				$(next).show();
			}else{
				$(next).hide();
			}
			return false;
		}else{
			return true;
		}
	});
	/*

	*/
	$("#icon-menu-responsive").click(function(event) {
		if( $("#nav-main").is(":hidden") ){
			$("#nav-main").slideDown("fast",function(){

			});
			$(this).addClass('active');
		}else{
			$("#nav-main").slideUp("fast",function(){
				$(this).removeAttr('style');
			});
			$(this).removeClass('active');
		}
	});
	/*
		Move to content
	*/
	$(".move-bottom").click(function(event) {
		var anchorTop = $("#anchor-top").offset();
		$("body,html").animate({
			scrollTop: anchorTop.top
		});
		return false;
	});
	function MakeSameHeightCustomer(){
	    if( $("body").find(".our-happy-customer").length > 0 ){
	    	var numberRow = 4,argsElement = [], maxH = 0;
		    var v = viewport();
			var w = v['width'];
		    $(".our-happy-customer .item .heading").removeAttr('style');
		    if( w >= 767 ){
		        numberRow = 3;
		    }else{
		    	return true;
		    }

	        $(".our-happy-customer .item").each(function( index ){
	            if( index % numberRow == 0 ){
	                $.each( argsElement , function( index, value ){
	                    $(this).find(".heading").css({
	                        height: maxH + "px"
	                    });
	                });
	                argsElement = [];
	                maxH = 0;
	            }
	            argsElement.push( $(this) );
	            var content = $(this).find(".heading");
	            if( $(content).outerHeight() > maxH ){
	                maxH = $(content).outerHeight();
	            }
	        });
	        if( argsElement.length > 0  ){
	            $.each( argsElement , function( index, value ){
	                $(this).find(".heading").css({
	                    height: maxH + "px"
	                });
	            });
	            argsElement = [];
	            maxH = 0;
	        }
	    }
	}
	/*
		Multicolumns
	*/
	$(".block-content-3-col").each(function(index, el) {
		var temp = $(this).find('.content-3-col-temp');
		var col  = $(this).find('.content-3-col');
		$(col).columnize({
			width : 400,
			target  : temp
		});
	});
	/*
		Gray Scale for image
	*/
	function BlackWhite(){
		if( $("body").find(".bwWrapper").length > 0 ){
			$('.bwWrapper').BlackAndWhite({
			    hoverEffect : true, // default true
			        // set the path to BnWWorker.js for a superfast implementation
			    webworkerPath : false,
			        // to invert the hover effect
			    invertHoverEffect: false,
			        // this option works only on the modern browsers ( on IE lower than 9 it remains always 1)
			    intensity:1,
			    speed: { //this property could also be just speed: value for both fadeIn and fadeOut
			        fadeIn: 200, // 200ms for fadeIn animations
			        fadeOut: 800 // 800ms for fadeOut animations
			    },
			    onImageReady:function(img) {
			        // this callback gets executed anytime an image is converted
			    }
		    });
		}
	}
	
	/* youtube play */
	function YotubePlay(){
		$(".youtube-play").each(function(index, el) {
			var youtubeCodeEl = $(this).find(".youtube-code"),
			button = $(this).find(".play"), that = $(this);
// 			
			$(button).click(function(event) {
				event.preventDefault();
				try{
					if( $(youtubeCodeEl).video("playing") ){
						$(youtubeCodeEl).animate({
							"opacity" : 0
							},
							500, function() {
						});
						$(that).removeClass('active');
						$(youtubeCodeEl).video("pause");
					}else{
						$(youtubeCodeEl).video("play");
						$(youtubeCodeEl).animate({
							"opacity" : 1
							},
							500, function() {
						});
						$(that).addClass('active');
					}
				}catch(ex){
					$(youtubeCodeEl).video();
// 					$(youtubeCodeEl).video("play");
				}
				
				return false;
			});
// 			var loaded = setInterval( function(){
// 				try{
// 					if( typeof $(youtubeCodeEl).video("pause") != "undefined" ){
// 						$(youtubeCodeEl).video("pause");
// 						$(youtubeCodeEl).animate({
// 							"opacity" : 0
// 							},
// 							500, function() {
// 						});
// 						clearInterval( loaded );
// 					}
// 				}catch(ex){
					
// 				}
				
// 			}, 500 );
		});
	}
	
	/*----------
		fancybox
		usage
			- add class fancybox.ajax if use ajax
			- add class fancybox.iframe if use iframe
	----------*/
	// fancybox Enhancement if it exists
	if( $().fancybox ){
		$(".popup").fancybox({
			maxWidth	: 800,
			maxHeight	: 600,
			fitToView	: false,
			width		: '70%',
			height		: '70%',
			autoSize	: false,
			closeClick	: false,
			openEffect	: 'none',
			closeEffect	: 'none'
		});
		$(".popup-subscription").fancybox({
			maxWidth	: 800,
			maxHeight	: 600,
			fitToView	: false,
			width		: '70%',
			height		: '70%',
			autoSize	: false,
			closeClick	: false,
			openEffect	: 'none',
			closeEffect	: 'none',
			wrapCSS     : 'homepage-subscription page-template-page-ajax-subscriptions',
			afterLoad   : function(){
				var content = $(this.content).find(".main-content").html();
				this.content = content;
			},
			afterShow  : function(){
				var content = $("body").find("#product-subscription");
				var selects = $(content).find(".custom-select");
				var form = $(content).find(".custom-variations");
				$.each(selects, function(index, el) {
					Select(el);
				});
				AjaxFunction(form);
			}
		});
		$(".fancybox-media").fancybox({
			maxWidth	: 800,
			maxHeight	: 600,
			fitToView	: false,
			width		: '70%',
			height		: '70%',
			autoSize	: false,
			closeClick	: false,
			openEffect	: 'none',
			closeEffect	: 'none',
			helpers : {
				media : {}
			}
		});
	}
	/*
		Scroll To top block video
	*/
	$(".wrapper-videos").each(function(){
		var _this = $(this),play = $(this).find('.play');
		$(play).click(function(event) {
			var offset = $(_this).offset();
			$("html,body").animate({
				scrollTop: offset.top
				},
				1000, function() {
			});
		});
	});
	$(window).load(function() {
		/*
			Masonry
		*/
		if( $("body").find(".faq").length > 0 ){
			$('.faq').masonry({
			  // options
			  itemSelector: '.item',
			  columnWidth: '.grid-sizer'
			});
		}
		// load youtube if browser is not IE < 8
		if( isIE() >= 9 || !isIE() ){
			$.getScript( jsData.load_script_youtube , function( data, textStatus, jqxhr ) {
				YotubePlay();
			});
		}
		BlackWhite();
	    $(this).trigger('resize');
	    setTimeout(function(){ 
	    	ScrollTo( window.location.href );
	    }, 1000);
	});
	var timer = window.setTimeout(function() {}, 0);
	$(window).resize(function(event) {
	    window.clearTimeout(timer);
	    timer = window.setTimeout(function() {
	      	MenuResponsive();
	      	MakeSameHeightCustomer();
	      	$(window).trigger('scroll');
	        window.clearTimeout(timer);
	    }, 500);
	});

	// home-blocks/product.php
	$(document).ready(function () {
		$("#add-to-cart").click(function () {
			$('#success-alert').removeClass('hidden');
		});
	});
});